import { render, staticRenderFns } from "./relevancedialog.vue?vue&type=template&id=57ba40e5&scoped=true"
import script from "./relevancedialog.vue?vue&type=script&lang=js"
export * from "./relevancedialog.vue?vue&type=script&lang=js"
import style0 from "./relevancedialog.vue?vue&type=style&index=0&id=57ba40e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ba40e5",
  null
  
)

export default component.exports